export enum SLAStatus {
    NotStarted = 1,
    InProgress = 2,
    ClientRefused = 3,
    CurrentSLA = 4,
    SLAExpired = 5,
    SLAExpiredRenewalInProgress = 6,
    CurrentSLAPendingDocumentUpload = 7
}